/**
 * Copyright (c) Simam Digital. Built on Project Flowerbed
 * (Copyright (c) Meta Platforms, Inc. and affiliates).
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { Component, Types } from 'ecsy';

/**
 * The player's personalization for their own garden/plot: a display name shown
 * on the HUD (and reused as their multiplayer name) plus an accent colour that
 * themes the HUD. A single instance lives on a singleton entity created by
 * PlotIdentitySystem, which persists it to localForage.
 */
export class PlotIdentityComponent extends Component {}

PlotIdentityComponent.schema = {
	/** @type {string} - player-chosen garden name (empty = use the default) */
	gardenName: { type: Types.String, default: '' },
	/** @type {string} - hex accent colour, e.g. '#5ec26a' (empty = default) */
	accentColor: { type: Types.String, default: '' },
	/** @type {boolean} - set when the identity changes so the system persists it */
	dirty: { type: Types.Boolean, default: false },
	/** @type {boolean} - set once the saved identity has loaded from storage */
	loaded: { type: Types.Boolean, default: false },
};
